<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="area"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="100%"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'AreaCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    unresolvedData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      unresolved: {
        lastYear: [],
        thisYear: [],
      },
      categories: [],
      chartOptions: {
        chart: {
          type: 'area',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
        },
        grid: {
          padding: {
            bottom: 20,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: 'top',
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          show: true,
          lineCap: 'butt',
          colors: ['#FFC107', '#2196F3'],
          dashArray: 0,
        },
        colors: ['#FFC107', '#2196F3'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.25,
            opacityTo: 0.75,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          type: 'category',
          categories: [],
        },
        markers: {
          size: 6,
        },
        annotations: {
          points: [],
          show: false,
        },
        // tooltip: {
        //   x: {
        //     format: 'dd/MM/yy HH:mm',
        //   },
        //   marker: false,
        // },
        tooltip: {
          custom: ({
            series, seriesIndex, dataPointIndex, w,
          }) => {
            const lastYearCount = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0 }).format(this.series[0].data[dataPointIndex])
            const thisYearCount = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0 }).format(this.series[1].data[dataPointIndex])
            const lastYearUnresolved = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0 }).format(this.unresolved.lastYear[dataPointIndex])
            const thisYearUnresolved = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0 }).format(this.unresolved.thisYear[dataPointIndex])
            return `
              <div class="arrow_box">
                <div>
                    <div class="resolved"><strong>${w.globals.seriesNames[1]}:</strong> ${thisYearCount}</div>
                    <div class="unresolved"><strong>${w.globals.seriesNames[1]}:</strong> ${thisYearUnresolved}</div>
                </div>
                <hr>
                <div>
                    <div class="resolved"><strong>${w.globals.seriesNames[0]}:</strong> ${lastYearCount}</div>
                    <div class="unresolved"><strong>${w.globals.seriesNames[0]}:</strong> ${lastYearUnresolved}</div>
                </div>
              </div>
            `
          },
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    unresolvedData: 'setData',
  },
  created() {
    this.setData()
    this.addAnnotations()
  },
  methods: {
    addAnnotations() {
      this.categories.forEach((month, index) => {
        if (this.unresolved.lastYear[index] > 0) {
          this.chartOptions.annotations.points.push({
            x: month,
            y: this.series[0].data[index],
            marker: {
              size: 6,
              fillColor: '#FF4560',
              strokeColor: '#FF4560',
              radius: 2,
              cssClass: 'unresolved-marker',
            },
          })
        }

        if (this.unresolved.thisYear[index] > 0) {
          this.chartOptions.annotations.points.push({
            x: month,
            y: this.series[1].data[index],
            marker: {
              size: 6,
              fillColor: '#FF4560',
              strokeColor: '#FF4560',
              radius: 2,
              cssClass: 'unresolved-marker',
            },
          })
        }
      })
    },
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.categories = this.categoriesData
      this.unresolved = this.unresolvedData
    },
  },
}
</script>
<style>
.arrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 4px;
  color: #333;
  font-size: 12px
}
.arrow_box:after,
.arrow_box:before {
  bottom: 100%;
  left: 50%;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.arrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 10px;
  margin-left: -10px;
}
.arrow_box:before {
  border-color: rgba(204, 204, 204, 0);
  border-bottom-color: #ccc;
  border-width: 11px;
  margin-left: -11px;
}
.arrow_box .unresolved{
  color: red;
}
</style>
